import { HashPlaceholderNode } from './nodes/browser/HashPlaceholderNode/HashPlaceholderNode.mjs';
import { ImageNode } from './nodes/browser/ImageNode/ImageNode.mjs';
import { UserProfileNode } from './nodes/browser/UserProfileNode.mjs';
import './nodes/headless/FallbackNode/code.mjs';
import './nodes/headless/FallbackNode/code-highlight.mjs';
import './nodes/headless/TimePresetNode/TimePresetNode.mjs';

const BROWSER_OPT_IN_FEATURE_NODES = {
  Placeholder: [HashPlaceholderNode],
  Image: [ImageNode],
  UserProfile: [UserProfileNode]
};
const BROWSER_OPT_IN_FEATURE_BLOCKS = {
  Placeholder: ["placeholder-chip"],
  Image: ["image"],
  UserProfile: ["user-profile"]
};

export { BROWSER_OPT_IN_FEATURE_BLOCKS, BROWSER_OPT_IN_FEATURE_NODES };
//# sourceMappingURL=constant.browser.mjs.map
